import type { LeadResponse } from '../../types/lead';
import CrmRecordForm from '../crm/CrmRecordForm';

export default function LeadEditForm({ lead, onUpdated, onCancel }: { lead: LeadResponse; onUpdated: () => void; onCancel?: () => void }) {
  return <CrmRecordForm kind="lead" lead={lead} onSaved={onUpdated} onCancel={onCancel || onUpdated} />;
}
